module.exports = __webpack_public_path__ + "static/media/notifications.c53fcaf6.svg";